module.exports = __webpack_public_path__ + "d8fcc9d5a092a07ad586ef9592ffeeee.png";